import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAuthenticationStore, { AuthenticationViews } from "./Store";
import KnownUserLogin from "./KnownUserLogin";

const KnownUserLoginContainer: React.FC = () => {
  const { state, dispatch, forgotPassword, finishLogin, setRememberMe } = useAuthenticationStore()
  const { serverError, isLoading, emailOrPhone } = state
  const navigate = useNavigate();

  const setEmailOrPhone = (newEmailOrPhone: string) => {
    dispatch({ type: 'SET_EMAIL_OR_PHONE', payload: newEmailOrPhone })
  }

  const handleSetRememberMe = (newRememberMe: boolean) => {
    setRememberMe(newRememberMe)
  }

  useEffect(() => {
    if (!emailOrPhone) {
      navigate('../' + AuthenticationViews.login)
    }
  }, [emailOrPhone, navigate])

  return (
    <KnownUserLogin
      serverError={serverError}
      isLoading={isLoading}
      emailOrPhone={emailOrPhone}
      notYouLink={"../" + AuthenticationViews.login}
      forgotPassword={forgotPassword}
      finishLogin={finishLogin}
      setEmailOrPhone={setEmailOrPhone}
      setRememberMe={handleSetRememberMe}
    />
  )
}

export default KnownUserLoginContainer